// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent, channel) => ({
  product: {
    name: 'product',
    componentName: 'ProductContainer',
    chunk: () => import(
      /* webpackChunkName: "product" */
      './pages/product/ProductContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/product/ProductContainer.js')).ProductContainer
        : currentRouteName === 'product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer })));
    },
    // https://www.homedepot.com/p/Some-Product-Name/123456789
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browse'],
    channel
  },
  collection: {
    name: 'collection',
    componentName: 'CollectionContainer',
    chunk: () => import(
      /* webpackChunkName: "collection" */
      './pages/collection/CollectionContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/collection/CollectionContainer.js')).CollectionContainer
        : currentRouteName === 'collection'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CollectionContainer })));
    },
    // https://www.homedepot.com/p/cabinet-seller/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-seller/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  collectionMobile: {
    name: 'collectionMobile',
    componentName: 'CollectionContainerMobile',
    chunk: () => import(
      /* webpackChunkName: "collectionMobile" */
      './pages/collection/CollectionContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/collection/CollectionContainer.js')).CollectionContainerMobile
        : currentRouteName === 'collectionMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.CollectionContainerMobile })
          ));
    },
    // https://www.homedepot.com/p/cabinet-seller/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-seller/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
    /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel
  },
  cabinetVisualizer: {
    name: 'cabinetVisualizer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      /* webpackChunkName: "collection" */
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/cabinetVisualizer/CabinetVisualizerContainer.js')).CabinetVisualizerContainer
        : currentRouteName === 'cabinetVisualizer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-shop-your-space/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  cabinetVisualizerMobile: {
    name: 'cabinetVisualizerMobile',
    componentName: 'CabinetVisualizerContainerMobile',
    chunk: () => import(
      './pages/cabinetVisualizer/CabinetVisualizerContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/cabinetVisualizer/CabinetVisualizerContainerMobile.js')).CabinetVisualizerContainerMobile
        : currentRouteName === 'cabinetVisualizerSpaceMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.CabinetVisualizerContainerMobile })
          ));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-shop-your-space/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  cabinetVisualizerDefault: {
    name: 'cabinetVisualizer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      /* webpackChunkName: "collection" */
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/cabinetVisualizer/CabinetVisualizerContainer.js')).CabinetVisualizerContainer
        : currentRouteName === 'cabinetVisualizer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space
    path: '/:context?/p/cabinet-shop-your-space/',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  cabinetVisualizerDefaultMobile: {
    name: 'cabinetVisualizerDefaultMobile',
    componentName: 'CabinetVisualizerContainerMobile',
    chunk: () => import(
      /* webpackChunkName: "collectionMobile" */
      './pages/cabinetVisualizer/CabinetVisualizerContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/cabinetVisualizer/CabinetVisualizerContainerMobile.js')).CabinetVisualizerContainerMobile
        : currentRouteName === 'cabinetVisualizer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space
    path: '/:context?/p/cabinet-shop-your-space/',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  cabinetVisualizerSDT: {
    name: 'cabinetVisualizer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      /* webpackChunkName: "collection" */
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/cabinetVisualizer/CabinetVisualizerContainer.js')).CabinetVisualizerContainer
        : currentRouteName === 'cabinetVisualizer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-shop-your-space/designs/Kitchen Cabinets/new/:omsId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  cabinetVisualizerSDTDefault: {
    name: 'cabinetVisualizer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      /* webpackChunkName: "collection" */
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/cabinetVisualizer/CabinetVisualizerContainer.js')).CabinetVisualizerContainer
        : currentRouteName === 'cabinetVisualizer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space
    path: '/:context?/p/cabinet-shop-your-space/designs/Kitchen Cabinets/new/',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  sandbox: {
    name: 'sandbox',
    componentName: 'SandboxContainer',
    chunk: () => import(
      /* webpackChunkName: "sandbox" */
      './pages/sandbox/SandboxContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/sandbox/SandboxContainer.js')).SandboxContainer
        : currentRouteName === 'sandbox'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.SandboxContainer })
          ));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/sandbox/:itemId',
    channel: 'desktop'
  },
  vehicleStorageMobile: {
    name: 'vehicleStorageMobile',
    componentName: 'VehicleStorageContainerMobile',
    chunk: () => import(
      /* webpackChunkName: "vehicleStorageMobile" */
      './pages/vehicleStorage/VehicleStorageContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/vehicleStorage/VehicleStorageContainerMobile.js')).VehicleStorageContainerMobile
        : currentRouteName === 'vehicleStorageMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.VehicleStorageContainerMobile })
          ));
    },
    // https://www.homedepot.com/p/build-your-rack-system/milwaukee-packout-rack/123456789
    path: '/:context?/p/build-your-rack-system/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  vehicleStorage: {
    name: 'vehicleStorage',
    componentName: 'VehicleStorageContainer',
    chunk: () => import(
      /* webpackChunkName: "vehicleStorage" */
      './pages/vehicleStorage/VehicleStorageContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/vehicleStorage/VehicleStorageContainer.js')).VehicleStorageContainer
        : currentRouteName === 'vehicleStorage'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.VehicleStorageContainer })
          ));
    },
    // https://www.homedepot.com/p/build-your-rack-system/milwaukee-packout-rack/123456789
    path: '/:context?/p/build-your-rack-system/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  wallStorageMobile: {
    name: 'wallStorageMobile',
    componentName: 'WallStorageContainerMobile',
    chunk: () => import(
      /* webpackChunkName: "wallStorageMobile" */
      './pages/wallStorage/WallStorageContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/wallStorage/WallStorageContainerMobile.js')).WallStorageContainerMobile
        : currentRouteName === 'wallStorageMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.WallStorageContainerMobile })
          ));
    },
    // Example: https://www.homedepot.com/p/build-your-wall-storage/some-wall-storage/123456789
    path: '/:context?/p/build-your-wall-storage/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  wallStorage: {
    name: 'wallStorage',
    componentName: 'WallStorageContainer',
    chunk: () => import(
      /* webpackChunkName: "wallStorage" */
      './pages/wallStorage/WallStorageContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/wallStorage/WallStorageContainer.js')).WallStorageContainer
        : currentRouteName === 'wallStorage'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.WallStorageContainer })
          ));
    },
    // Example: https://www.homedepot.com/p/build-your-wall-storage/some-wall-storage/123456789
    path: '/:context?/p/build-your-wall-storage/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
});
